var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`course-${_vm.course.id}`},[(_vm.$route.meta.hideHeader)?_c('div',{staticClass:"shell-header-top no-banner"}):_c('teesheet-header',{attrs:{"banner-size":"large"}}),_vm._v(" "),(!_vm.loaded)?[_vm._v("\n\t\tLoading...\n\t")]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }